import styled from "styled-components";
import Link from "../Link";

export const StyledLink = styled(Link)`
  display: flex;
  justify-content: ${(props) => props.linkTextAlignment};
  align-items: center;
  font-weight: 700;
  ${(props) => props.extraStyles}

  .icon {
    /* Force to center to the text */
    height: 16px;
  }

  &:focus {
    background-color: var(--dui-color-black-500);
    color: var(--dui-color-white-500);
    padding: 4px 3px 1px;
    text-decoration: underline;

    svg {
      fill: var(--dui-color-white-500);
    }
  }
`;

export const StyledText = styled.span`
  padding-right: 8px;
`;
